"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validation = exports.ValidationTemplates = void 0;
/** A set of templates to create ValidationFunctions for common validation problems */
exports.ValidationTemplates = {
    /** Builds a ValidationFunction that will return an error message for Falsy values */
    required: (errorMsg) => (value) => !value ? errorMsg : null,
    /** Builds a generator that will create ValidationFunctions to verify minimum length */
    minLength: (errorMsg) => (min) => (value) => value.length < min ? errorMsg : null,
    /** Builds a generator that will create ValidationFunctions to verify maximum length */
    maxLength: (errorMsg) => (max) => (value) => value.length > max ? errorMsg : null,
    /** Builds a generator that will create ValidationFunctions to verify minimum value */
    min: (errorMsg, typeErrorMsg) => (min) => (value) => {
        if (isNaN(Number(value))) {
            return typeErrorMsg;
        }
        return Number(value) < min ? errorMsg : null;
    },
    /** Builds a generator that will create ValidationFunctions to verify maximum value */
    max: (errorMsg, typeErrorMsg) => (max) => (value) => {
        if (isNaN(Number(value))) {
            return typeErrorMsg;
        }
        return Number(value) > max ? errorMsg : null;
    },
    /** Builds a generator that will create ValidationFunctions to verify a regex pattern */
    pattern: (errorMsg) => (pattern) => (value) => value.match(pattern) === null ? errorMsg : null,
    /** Builds a ValidationFunction that will return an error message for non-Number inputs */
    numbersOnly: (errorMsg) => (value) => isNaN(Number(value)) ? errorMsg : null,
};
/** A set of ValidationFunctions (or ValidationFunction generators) for common validation problems */
exports.Validation = {
    /** A ValidationFunction to ensure a value is Truthy */
    required: exports.ValidationTemplates.required("This field is required."),
    /** Generates a ValidationFunction to ensure a minimum length is met */
    minLength: exports.ValidationTemplates.minLength("This value is too short."),
    /** Generates a ValidationFunction to ensure a maximum length is met */
    maxLength: exports.ValidationTemplates.maxLength("This value is too long."),
    /** Generates a ValidationFunction to ensure a minimum value is met */
    min: exports.ValidationTemplates.min("This value is too low.", "Please use a number."),
    /** Generates a ValidationFunction to ensure a maximum value is met */
    max: exports.ValidationTemplates.max("This value is too high", "Please use a number."),
    /** Generates a ValidationFunction to ensure input follows a certain RegExp pattern */
    pattern: exports.ValidationTemplates.pattern("Does not match the required pattern."),
    /** A ValidationFunction to ensure a value is a number */
    numbersOnly: exports.ValidationTemplates.numbersOnly("Please use a number."),
};
